import * as React from 'react';
import uuid from 'uuid';
import hoistStatics from 'hoist-non-react-statics';

const document = typeof window === 'undefined' ? {} : window.document;

type Title = {
  id: string;
  body: string;
};

let titles: Title[] = [];

export function unset(id: string) {
  titles = titles.filter((title) => title.id !== id);
  refreshTitle();
}

export function set(body: string): string {
  const title = { id: uuid.v4(), body };
  titles.push(title);
  refreshTitle();
  return title.id;
}

function refreshTitle() {
  if (titles.length > 0) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type '{}'.
    document.title = titles[titles.length - 1].body;
  } else {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type '{}'.
    document.title = 'Remind';
  }
}

export function withDocumentTitle<Props extends {}>(
  body: string,
  ComposedComponent: React.ComponentType<Props>
) {
  class HOC extends React.Component<Props> {
    componentDidMount() {
      this.id = set(body);
    }

    componentWillUnmount() {
      unset(this.id);
    }

    // @ts-expect-error ts-migrate(2564) FIXME: Property 'id' has no initializer and is not defini... Remove this comment to see the full error message
    id: string;

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  return hoistStatics(HOC, ComposedComponent);
}
